import { connect } from 'react-redux';

import { makeSelectFilters, changeFilters, makeSelectObjectsArray, makeSelectOffset, makeSelectCount, makeSelectInProgress, changeSearchStr, requestObjects, changeOffset, changeSort } from '../../../../store/Objects';
import { IStateType } from '../../../../store/models/root.interface';

import Logs, {
    DispatchPropsType,
    MapStateType,
} from '../organisms/logs';
import { Instances } from '../../../../constants';
import { getData } from '../../../../store/actions/whatsappLogs.action';
import { OrderingRuleType } from '../../../../interface';

export const mapInstanceWithWAChannel: Record<string, Instances>= {
    'messageLogsV1': Instances.whatsappLogs,
    'messageLogsV2': Instances.whatsappLogsV2,
    'voiceLogsV1': Instances.whatsappVoiceLogs,
    'voiceLogsV2': Instances.whatsappVoiceLogs,
}

const mapStateToProps = (state: IStateType) => ({
    appliedFilters: makeSelectFilters(Instances.whatsappLogs)(state),
    //Data for all 3 channels
    logsData: makeSelectObjectsArray(Instances.whatsappLogs)(state),
    v2LogsData: makeSelectObjectsArray(Instances.whatsappLogsV2)(state),
    voiceData: makeSelectObjectsArray(Instances.whatsappVoiceLogs)(state),
    //Page for all 3 channels
    page: makeSelectOffset(Instances.whatsappLogs)(state),
    v2Page: makeSelectOffset(Instances.whatsappLogsV2)(state),
    voicePage: makeSelectOffset(Instances.whatsappVoiceLogs)(state),
    //Total for all 3 channels
    total: makeSelectCount(Instances.whatsappLogs)(state),
    v2Total: makeSelectCount(Instances.whatsappLogsV2)(state),
    voiceTotal: makeSelectCount(Instances.whatsappVoiceLogs)(state),
    //InProgress for all 3 channels
    inProgress: makeSelectInProgress(Instances.whatsappLogs)(state),
    v2InProgress: makeSelectInProgress(Instances.whatsappLogsV2)(state),
    voiceInProgress: makeSelectInProgress(Instances.whatsappVoiceLogs)(state),
    //Other data other than array of logs
    data: state.whatsappLogs,
    //waba details
    wabaID: state.wabaId,
});

const mapDispatchToProps = (dispatch: any) => ({
    onFilter: (filters: Record<string, any> | undefined, logsFor: string) => {
        dispatch(changeFilters(
            mapInstanceWithWAChannel[logsFor],
            filters as Record<string, any>
        ))
    },
    onSearchStrChange: (logsFor: string,searchStr?: string) => { dispatch(changeSearchStr(mapInstanceWithWAChannel[logsFor], searchStr || '')) },
    onLoad: (logsFor: string, wabaID?: string|number) => dispatch((requestObjects(mapInstanceWithWAChannel[logsFor], { wabaID: wabaID }, { property: "logs", searchTerm: "phone_number" }))),
    onPaginate: (logsFor: string) => dispatch(changeOffset(mapInstanceWithWAChannel[logsFor])),
    onLoadData: (logsFor:string, wabaID?: string|number) => dispatch(getData(logsFor, wabaID)),
    onSort: (logsFor: string, sort: OrderingRuleType[]) =>  dispatch(changeSort(mapInstanceWithWAChannel[logsFor], sort)),
});

export default connect<MapStateType, DispatchPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(Logs);
